import styled from 'styled-components';

const PopUpArea = styled.div`
  position: absolute;
  ${({ cssExt }) => cssExt && cssExt}
`;

export default function PopUp({ children, cssExt, isShow }) {
  return (
    <PopUpArea show={isShow} cssExt={cssExt}>
      {children}
    </PopUpArea>
  );
}
